<template>
  <div class="app-login">
    <dyn-slot :slot-data="slotData"><slot name="txtBefore"></slot></dyn-slot>
    <b-form
      inline
      @submit.prevent="login()"
      :id="'form' + _uid"
      :novalidate="true"
      data-form-login
      class="login-form"
    >
      <label class="col-form-label label-before" :for="'login-username_' + _uid"><dyn-slot :slot-data="slotData"><slot name="lblBefore">Login</slot></dyn-slot></label>
      <legend class="visually-hidden">Login Informationen</legend>
      <b-form-group :id="'login-username_' + _uid" class="form-group-username">
        <label class="col-form-label label-username" :for="'login-username_' + _uid"><dyn-slot :slot-data="slotData"><slot name="lblUsername">Username</slot></dyn-slot></label>
        <b-form-input
          data-username
          type="text"
          required
          :placeholder="usernamePlaceholder"
          v-model.trim="username"
          @input="$v.username.$touch"
          :state="isValid('username')"
          :disabled="loading"
          class="username-input"
        ></b-form-input>
        <b-form-invalid-feedback class="username-login-error" v-if="displayErrorMessage">
          Sie haben keine gültige Rufnummer angegeben
        </b-form-invalid-feedback>
      </b-form-group>
      <label class="col-form-label label-between" :for="'login-password_' + _uid"><dyn-slot :slot-data="slotData"><slot name="lblBetween"></slot></dyn-slot></label>
      <b-form-group :id="'login-password_' + _uid" class="form-group-password">
        <label class="col-form-label label-password" :for="'login-password_' + _uid"><dyn-slot :slot-data="slotData"><slot name="lblPassword">Password</slot></dyn-slot></label>
        <b-form-input
          data-password
          type="password"
          required
          :placeholder="passwordPlaceholder"
          @input="$v.password.$touch"
          :state="isValid('password')"
          v-model="password"
          :disabled="loading"
          class="password-input"
        ></b-form-input>
        <b-form-invalid-feedback class="password-login-error" v-if="displayErrorMessage">
          Sie haben kein gültiges Passwort eingegeben.
        </b-form-invalid-feedback>
        <slot name="txtAfterPassword"></slot>
      </b-form-group>
      <b-overlay :show="loading" class="btn-overlay" spinner-small>
        <b-button :id="'submit-'+_uid" type="submit" variant="primary" class="btn-login" :disabled="$v.$invalid || loading">
          <slot name="btnNext">Login</slot>
        </b-button>
      </b-overlay>
    </b-form>
    <dyn-slot :slot-data="slotData"><slot name="txtAfter"></slot></dyn-slot>
  </div>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BOverlay } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import { onLogin } from '@/apollo'
import isValid from '../../../../../mixins/isValid'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      displayErrorMessage: false,
      loading: false
    }
  },
  props: {
    usernamePlaceholder: {
      type: String,
      default: 'Rufnummer'
    },
    passwordPlaceholder: {
      type: String,
      default: 'Passwort'
    }
  },
  components: {
    BButton, BFormGroup, BFormInput, BForm, BFormInvalidFeedback, BOverlay
  },
  methods: {
    login () {
      if (this.$v.$invalid) {
        return
      }
      const component = this
      this.loading = true
      this.$store.dispatch('login', { username: this.username, password: this.password }).then(jwt => {
        // login for apollo client
        onLogin(component.$apolloProvider.defaultClient, jwt)

        document.querySelectorAll('.disableOnLogout').forEach((elm) => {
          elm.removeAttribute('disabled')
        })
        // login for cms
        const portalLoginForm = document.querySelector('form.mod_login')
        if (portalLoginForm) {
          portalLoginForm.querySelector('[name=username]').value = 'jwt'
          portalLoginForm.querySelector('[name=password]').value = jwt
          portalLoginForm.submit()
        } else {
          this.loading = false
        }
      }, error => {
        if (error.response && error.response.data) {
          component.$store.commit('addError', error.response.data)
        } else if (error.message) {
          component.$store.commit('addError', { message: error.message })
        } else {
          component.$store.commit('addError', 'technical error!')
        }
        this.loading = false
      })
    }
  },
  mixins: [validationMixin, isValid],
  validations () {
    return {
      username: {
        required,
        isPhoneNumber
      },
      password: {
        required
      }
    }
  },
  computed: {
    slotData () {
      return {
        username: this.username,
        displayErrorMessage: this.displayErrorMessage,
        loading: this.loading
      }
    }
  }
}
</script>
